import React from "react";
import { useNavigate } from "react-router-dom";
import Logo from "../assets/Images/Logo-white.png";

const Categories = () => {
  const navigate = useNavigate();

  const categories = [
    {
      id: "mens-beginners-doubles",
      name: "Men's Beginners Doubles",
      description: "2 tournament points per match win",
      icon: "🎾",
      color: "from-blue-500 to-blue-600",
      bgColor: "bg-blue-50",
      borderColor: "border-blue-200",
    },
    {
      id: "womens-doubles-intermediate",
      name: "Women's Doubles (Intermediate)",
      description: "2 tournament points per match win",
      icon: "🥎",
      color: "from-pink-500 to-pink-600",
      bgColor: "bg-pink-50",
      borderColor: "border-pink-200",
    },
    {
      id: "mixed-doubles-advance",
      name: "Mixed Doubles (Advance)",
      description: "2 tournament points per match win",
      icon: "🧑‍🤝‍🧑",
      color: "from-purple-500 to-purple-600",
      bgColor: "bg-purple-50",
      borderColor: "border-purple-200",
    },
    {
      id: "mens-split-30-intermediate",
      name: "Men's Split Age 30+ Doubles (Intermediate)",
      description: "2 tournament points per match win",
      icon: "🎯",
      color: "from-orange-500 to-orange-600",
      bgColor: "bg-orange-50",
      borderColor: "border-orange-200",
    },
    {
      id: "mens-doubles-intermediate",
      name: "Men's Doubles (Intermediate)",
      description: "2 tournament points per match win",
      icon: "👬",
      color: "from-green-500 to-green-600",
      bgColor: "bg-green-50",
      borderColor: "border-green-200",
    },
    {
      id: "mens-split-30-advance",
      name: "Men's Split Age 30+ Doubles (Advance)",
      description: "2 tournament points per match win",
      icon: "🏅",
      color: "from-teal-500 to-teal-600",
      bgColor: "bg-teal-50",
      borderColor: "border-teal-200",
    },
    {
      id: "mens-doubles-advance",
      name: "Men's Doubles (Advance)",
      description: "3 tournament points per match win",
      icon: "🏆",
      color: "from-amber-500 to-amber-600",
      bgColor: "bg-amber-50",
      borderColor: "border-amber-200",
    },
  ];

  const handleCategoryClick = (category) => {
    navigate(`/category/${category.name}`);
  };

  return (
    <div className="min-h-screen">
      {/* Header */}
      <div
        style={{
          background:
            "linear-gradient(99.32deg, rgb(1, 30, 72) -0.41%, rgb(17, 64, 132) 93.61%)",
        }}
        className="text-white p-6 pb-8"
      >
        <h1 className="text-2xl font-bold text-center mb-3 mt-8">Live Score</h1>
        <p className="text-center text-sm opacity-90 mb-3 mt-4">Powered by</p>
        <div className="flex justify-center mb-8">
          <img src={Logo} alt="PLLAYER" className="h-8" />
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-md mx-auto">
        <div className="space-y-4 p-4">
          {categories.map((category) => (
            <div
              key={category.id}
              onClick={() => handleCategoryClick(category)}
              className={`${category.bgColor} ${category.borderColor} border-2 rounded-lg p-6 cursor-pointer transition-all hover:shadow-lg hover:scale-105`}
            >
              <div className="flex items-center space-x-4">
                <div
                  className={`w-16 h-16 rounded-full bg-gradient-to-r ${category.color} flex items-center justify-center text-white text-2xl`}
                >
                  {category.icon}
                </div>
                <div className="flex-1">
                  <h3 className="text-lg font-semibold text-gray-800 mb-1">
                    {category.name}
                  </h3>
                  <p className="text-sm text-gray-600">
                    {category.description}
                  </p>
                </div>
                <div className="text-gray-400">
                  <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Categories;
